import { render, staticRenderFns } from "./calendar-add.vue?vue&type=template&id=7ff166da&"
import script from "./calendar-add.vue?vue&type=script&lang=js&"
export * from "./calendar-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports